import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { GalleryApiItem, GalleryApiPage } from '../models/gallery.model';

@Injectable({ providedIn: 'root' })
export class GalleryService {
  private base = `${environment.apiUrl}/api/v2/galleries`;

  constructor(private http: HttpClient) {}

  /** Liste paginée des galeries publiques */
  getGalleries(page = 1, perPage = 12): Observable<GalleryApiPage> {
    const params = new HttpParams()
      .set('page', page)
      .set('per_page', perPage);
    return this.http.get<GalleryApiPage>(this.base, { params });
  }

  /** Détail d'une galerie (incrémente les vues) */
  getGallery(id: number): Observable<{ data: GalleryApiItem }> {
    return this.http.get<{ data: GalleryApiItem }>(`${this.base}/${id}`);
  }
}
